import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export function getOrgHeaders(extraHeaders = {}) {
  const slug = localStorage.getItem("orgSlug");
  return {
    ...(slug ? { "X-Org-Slug": slug } : {}),
    ...extraHeaders,
  };
}

// Pre-configured axios instance that always includes the org header
const api = axios.create({ baseURL: API_BASE_URL });

api.interceptors.request.use((config) => {
  const slug = localStorage.getItem("orgSlug");
  if (slug) config.headers["X-Org-Slug"] = slug;
  return config;
});

export default api;